import React, { useState } from 'react';
import { Box, Typography, Container } from '@mui/material';
import BookingForm from './BookingForm';

const HeroSection = () => {
  const [tabValue, setTabValue] = useState(0);
  const [tripType, setTripType] = useState('oneway');

  const getHeroImage = () => {
    if (tabValue === 0) {
      return tripType === 'oneway'
        ? '/trip-image/Affordable trips.png'
        : '/trip-image/Weekend trips.png';
    }
    if (tabValue === 1) return '/trip-image/Airport.png';
    return '/trip-image/Affordable trips.png';
  };

  const currentImage = getHeroImage();

  return (
    <Box
      sx={{
        position: 'relative',
        zIndex: 10,
        width: '100%',
        backgroundColor: { xs: '#ffffff', md: 'transparent' },
        pt: { xs: 0, md: 10 },
        pb: { xs: 0, md: 0 },
        my: { xs: 0, md: "auto" }
      }}
    >
      <style>
        {`
          @keyframes slideInFromRight {
            0% { 
              opacity: 0; 
              transform: translateX(40px); 
            }
            100% { 
              opacity: 1; 
              transform: translateX(0); 
            }
          }
        `}
      </style>
      <Container maxWidth={false} disableGutters sx={{ px: 0, maxWidth: { xs: '100vw', md: '1200px' }, mx: 'auto' }}>
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: "center",
          justifyContent: { xs: "center", md: "space-between" },
          gap: { xs: 4, md: 0 },
          width: '100%',
          backgroundColor: { xs: '#ffffff', md: 'transparent' }
        }}>
          {/* Left Content Column */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' }, // Hide cleanly on mobile form view
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              px: { xs: 2, md: 0 },
              width: '100%',
              flex: 1.2,
              maxWidth: { md: '450px', lg: '550px' },
              gap: { xs: 2, md: 0 } // Gap between text and image on mobile
            }}
          >
            {/* Heading - Responsive Scaling */}
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: '1.4rem', sm: '1.8rem', md: '1.2rem', lg: '1.6rem' },
                color: '#1A1A2E',
                lineHeight: 1.15,
                mb: { xs: 0.5, md: 2 },
                textAlign: 'center',
                fontFamily: "'Poppins', sans-serif",
                maxWidth: '100%'
              }}
            >
              Book{' '}
              <Box
                component="span"
                sx={{
                  textDecoration: 'underline',
                  textDecorationColor: '#5B2D8E',
                  textUnderlineOffset: '8px',
                  textDecorationThickness: '2px',
                }}
              >
                Any Vehicle
              </Box>{' '}
              to Anywhere!
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: '0.85rem', md: '1.1rem' },
                color: '#5B2D8E',
                fontStyle: 'italic',
                fontWeight: 500,
                mt: 0,
                mb: { xs: 1, md: 4 },
                textAlign: 'center',
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              -With Driver
            </Typography>

            {/* Illustration - Fluid Viewport Scaling */}
            <Box
              sx={{
                width: '100%',
                height: { xs: '180px', md: '55vh', lg: '60vh' },
                maxHeight: '500px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'visible',
              }}
            >
              <Box
                key={currentImage}
                component="img"
                src={currentImage}
                alt="Vehicle Booking Illustration"
                sx={{
                  width: 'auto',
                  height: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                  filter: !currentImage.includes('trip-image') ? 'drop-shadow(0 12px 30px rgba(91, 45, 142, 0.15))' : 'none',
                  animation: 'slideInFromRight 0.6s ease-out forwards',
                  borderRadius: currentImage.includes('trip-image') ? '24px' : '0px',
                  display: 'block',
                }}
              />
            </Box>
          </Box>

          {/* Right Form Column */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-end' },
              width: '100%',
              flex: 1
            }}
          >
            <Box sx={{ width: '100%', maxWidth: { xs: 'none', md: '420px' } }}>
              <BookingForm
                tabValue={tabValue}
                setTabValue={setTabValue}
                tripType={tripType}
                setTripType={setTripType}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
